/* tslint:disable */
/* eslint-disable */
export enum WorkProjectdossierSourceEnum {
  ProjectDocument = 'PROJECT_DOCUMENT',
  ProjectPhoto = 'PROJECT_PHOTO',
  ItemDocument = 'ITEM_DOCUMENT',
  SupplierDocument = 'SUPPLIER_DOCUMENT',
  InternalDocument = 'INTERNAL_DOCUMENT'
}
